// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"EmployeeDashboardAllApplicants_hidescrollbar__5Nzw1","input":"EmployeeDashboardAllApplicants_input__eGrLM"};